<!-- delivery partner map -->

<div class="ad-model-container mb-0">
  <div class="ad-model-header d-flex flex-column gap-2">
    <div class="w-100 d-flex flex-row justify-content-between align-items-center ad-model-header-inner">
      <h4 class="mb-0 d-flex align-items-start justify-content-start flex-column gap-1">
        <span>3PL Map</span>
        <span class="vendor-name text-first-letter line-clamp-1 d-flex align-items-center gap-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
            <g fill="none" stroke="currentColor" stroke-width="1.5">
              <path
                d="M3.5 11v3c0 3.771 0 5.657 1.172 6.828S7.729 22 11.5 22h1c3.771 0 5.657 0 6.828-1.172S20.5 17.771 20.5 14v-3" />
              <path d="M9.5 2h5l.652 6.517a3.167 3.167 0 1 1-6.304 0z" />
              <path
                d="M3.33 5.351c.178-.89.267-1.335.448-1.696a3 3 0 0 1 1.888-1.548C6.056 2 6.51 2 7.418 2H9.5l-.725 7.245a3.06 3.06 0 1 1-6.043-.904zm17.34 0c-.178-.89-.267-1.335-.448-1.696a3 3 0 0 0-1.888-1.548C17.944 2 17.49 2 16.582 2H14.5l.725 7.245a3.06 3.06 0 1 0 6.043-.904z" />
              <path stroke-linecap="round"
                d="M9.5 21.5v-3c0-.935 0-1.402.201-1.75a1.5 1.5 0 0 1 .549-.549C10.598 16 11.065 16 12 16s1.402 0 1.75.201a1.5 1.5 0 0 1 .549.549c.201.348.201.815.201 1.75v3" />
            </g>
          </svg>
          <small class="text-first-letter">
            ({{userData.fullName}})
          </small>
        </span>
      </h4>

      <div class="d-flex justify-content-end align-items-end gap-2 ad-me-8">
        @if(dp_setup == 'Own Cluster'){
        <div class="action-buttons-container">
          <button type="button" placement="top" class="btn ad-btn-small" (click)="customerCluster()">
            <span>Own cluster </span>
          </button>
        </div>
        }
        @if(userData.role_id == constant.RoleId.masterAgency || userData.role_id == constant.RoleId.agency) {

        <div class="ad-form-group ad-assign-method mb-0">
          <label class="ad-control-label">Change All Customer 3pl Setup</label>
          <ng-select class="ad-select" bindLabel="name" bindValue="value" placeholder="Select"
            (change)="onApplyDpSetupChange($event)" [(ngModel)]="apply_dp_setup" [searchable]="true" [clearable]="false"
            [items]="applydpList">
          </ng-select>
        </div>
        }
        @if(userData.role_id == constant.RoleId.vendor) {
        <div class="ad-form-group ad-assign-method mb-0">
          <label class="ad-control-label">Dp setup</label>
          <ng-select class="ad-select" bindLabel="name" bindValue="value" placeholder="Select"
            (change)="dpSetupMethod()" [(ngModel)]="dp_setup" [searchable]="true" [clearable]="false" [items]="dpList">
          </ng-select>
        </div>
        }

        <!-- @if( deliveryPartnerIds.includes(constant.deliveryPartnerViaOndc)&& ondcActiveCheck) {
          <div class="ad-form-group ad-assign-method mb-0 cus-max-w-170">
            <label class="ad-control-label">ONDC 3pl Mapping</label>
            <ng-select class="ad-select" bindLabel="name" bindValue="url" placeholder="Select"
                [(ngModel)]="ondcConfigListData" [searchable]="true" [closeOnSelect]="false" [clearable]="true"multiple="true" [items]="ondcConfigList">
            </ng-select>
          </div>
        } -->
        <div class="ad-form-group ad-assign-method mb-0">
          <label class="ad-control-label">3PL Assign Method</label>
          <ng-select class="ad-select" bindLabel="name" bindValue="name" placeholder="Select"
            (change)="thirdPartyMethod()" [(ngModel)]="dp_push_mechanisum" [searchable]="true" [clearable]="false"
            [items]="constant.dpAssignMethod">
          </ng-select>
        </div>

        <!-- <div class="rtb-checkbox">
          <div class="checkbox checkbox-primary">
            <input id="checkbox-primary-1" type="checkbox" [checked]="dp_rearrange_with_eta"
              (change)="checkValue($event)">
            <label for="checkbox-primary-1">Reassign with ETA</label>
          </div>
        </div> -->
      </div>
    </div>
    <div class="ad-close" data-dismiss="modal" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m7 7l10 10M7 17L17 7"
          stroke-width="1" />
      </svg>
    </div>
  </div>
  @if (deliveryPartnerShow) {
  <div class="ad-delivery-partner-container" [class.blurred-container]="dp_setup !== 'Own'">
    <div class="ad-delivery-partner-container-inner" dragula="DPM" [(dragulaModel)]="UserDeliveryPartnerMap"
      (dragulaModelChange)="interChangeList($event)">
      @for (dp of UserDeliveryPartnerMap; track dp; let i = $index) {
      <div class="ad-delivery-main-card" style="padding: 10px 50px 10px 10px; position: relative;">
        <div class="d-flex justify-content-start align-items-center gap-2">
          <div class="ad-partner-header d-flex flex-row justify-content-start align-items-center">
            <div class="ad-partner-logo">
              <img [src]="dp?.DeliveryPartner?.icon_url"
                style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;"
                (error)="dp.DeliveryPartner.icon_url = 'assets/images/error-img-3pl.png';" alt="partner logo">
            </div>
            <h6 class="mb-0 text-ellips-1 ">{{dp?.DeliveryPartner?.full_name}}</h6>
          </div>
          @if(dp_push_mechanisum == 'Parallel' && dp.delivery_partner_user_id == 1 || dp_push_mechanisum !=
          'Parallel'){
          <div class="ad-partner-wrapper d-flex justify-content-end align-items-center">
            <div class="ad-timer-container d-flex flex-row justify-content-start align-items-center gap-2">
              <small class="mr-2">Waiting time (mins)</small>
              <div class="position-relative">
                <input type="number" class="ad-form-control" (keyup)="editFunction($event,i,'waiting_time_in_min');"
                  (blur)="validateWaitingTime($event,i)" min="1" max="60" [ngModel]="dp.waiting_time_in_min"
                  (ngModelChange)="dp.waiting_time_in_min = $event > 0 && $event <= 60 ? Math.abs($event) : null"
                  [name]="dp.DeliveryPartner.full_name" style="width: 50px; border-radius: 5px;"
                  [title]="'Enter a number between 1-60 minutes'" appOnlyNumber>
              </div>
            </div>
          </div>
          }
        </div>

        <div class="d-flex justify-content-end align-items-center gap-2">
          <div class="ad-partner-wrapper d-flex justify-content-end align-items-center w-10">
            <div class="d-flex flex-row justify-content-start align-items-center gap-2">
              <small class="mr-2">Min KM</small>
              <div class="position-relative">
                <input type="number" class="ad-form-control" min="1" max="5" [ngModel]="dp.min_km"
                  (keyup)="editFunction($event,i,'min_km')" [name]="dp?.DeliveryPartner?.full_name"
                  style="width: 75px; border-radius: 5px;" [title]="'Enter a number between 0-5 km'" appOnlyNumber>
              </div>
            </div>
          </div>
          <div class="ad-partner-wrapper d-flex justify-content-end align-items-center">
            <div class="d-flex flex-row justify-content-start align-items-center gap-2">
              <small class="mr-2">Max KM</small>
              <div class="position-relative">
                <input type="number" class="ad-form-control" min="1" max="5" [ngModel]="dp.max_km"
                  (keyup)="editFunction($event,i,'max_km')" [name]="dp?.DeliveryPartner?.full_name"
                  style="width: 75px; border-radius: 5px;" [title]="'Enter a number between 1-50 km'" appOnlyNumber>
              </div>
            </div>
          </div>
          @if (dp?.DeliveryPartner?.allow_cod_order) {
          <div class="ad-status-container cursor-pointer">
            <div class="media ad-custom--switch">
              <div class="media-body icon-state">
                <label class="switch">
                  <input type="checkbox" [id]="'checkbox1' + i" (change)="allowCod($event,i)"
                    [checked]="dp.allow_cod" /><span class="switch-state"></span>
                </label>
              </div>
              <label for="test" class="col-form-label ">COD</label>
            </div>
          </div>
          }
          <div class="ad-status-container cursor-pointer">
            <div class="media ad-custom--switch">
              <div class="media-body icon-state">
                <label class="switch">
                  <input type="checkbox" [id]="'checkbox' + i" (change)="activeAndInactive($event,i)"
                    [checked]="dp.status==='Active'" /><span class="switch-state"></span>
                </label>
              </div>
              <label for="test" class="col-form-label ">Active</label>
            </div>
          </div>
          <div class="ad-status-container">
            <div class="ad-delete-icon cursor-pointer" (click)="deleteDeliveryPartner(dp,i)">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#8B8484">
                <path fill="currentColor"
                  d="M3 6.524c0-.395.327-.714.73-.714h4.788c.006-.842.098-1.995.932-2.793A3.68 3.68 0 0 1 12 2a3.68 3.68 0 0 1 2.55 1.017c.834.798.926 1.951.932 2.793h4.788c.403 0 .73.32.73.714a.72.72 0 0 1-.73.714H3.73A.72.72 0 0 1 3 6.524" />
                <path fill="currentColor" fill-rule="evenodd"
                  d="M11.596 22h.808c2.783 0 4.174 0 5.08-.886c.904-.886.996-2.34 1.181-5.246l.267-4.187c.1-1.577.15-2.366-.303-2.866c-.454-.5-1.22-.5-2.753-.5H8.124c-1.533 0-2.3 0-2.753.5s-.404 1.289-.303 2.866l.267 4.188c.185 2.906.277 4.36 1.182 5.245c.905.886 2.296.886 5.079.886m-1.35-9.811c-.04-.434-.408-.75-.82-.707c-.413.043-.713.43-.672.864l.5 5.263c.04.434.408.75.82.707c.413-.044.713-.43.672-.864zm4.329-.707c.412.043.713.43.671.864l-.5 5.263c-.04.434-.409.75-.82.707c-.413-.044-.713-.43-.672-.864l.5-5.264c.04-.433.409-.75.82-.707"
                  clip-rule="evenodd" />
              </svg>
            </div>
          </div>
          <div class="ad-drag">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#8B8484">
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M16 13l6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z" />
            </svg>
          </div>
        </div>
      </div>
      <!-- KM Validation Error Message -->
      @if (kmValidationErrors[i]) {
      <div class="km-validation-error">
        <p class="mb-0 ad-errors">{{kmValidationErrors[i]}}</p>
      </div>
      }
      }

      @if (!UserDeliveryPartnerMap.length) {
      <div class="ad-no-data-container">
        <img src="assets/data-img/nodata.png" alt="no-delivery-partner">
        <p class="mt-3 mb-3">There is no delivery partners</p>
        <a class="btn ad-btn-small active" (click)="deliveryPartnerAdd()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" stroke="currentColor" stroke-width="1.5">
              <path
                d="M2.364 12.958c-.38-2.637-.57-3.956-.029-5.083s1.691-1.813 3.992-3.183l1.385-.825C9.8 2.622 10.846 2 12 2s2.199.622 4.288 1.867l1.385.825c2.3 1.37 3.451 2.056 3.992 3.183s.35 2.446-.03 5.083l-.278 1.937c-.487 3.388-.731 5.081-1.906 6.093S16.553 22 13.106 22h-2.212c-3.447 0-5.17 0-6.345-1.012s-1.419-2.705-1.906-6.093z" />
              <path stroke-linecap="round" d="M15 13h-3m0 0H9m3 0v-3m0 3v3" />
            </g>
          </svg>
          <span>Add Delivery Partners</span>
        </a>
      </div>
      }
    </div>

    <!-- Blurred Overlay for non-Own dp_setup -->
    @if (dp_setup !== 'Own' || (userData.role_id != constant.RoleId.vendor && apply_dp_setup == 'Own') ||
    (userData.role_id != constant.RoleId.vendor && apply_dp_setup == 'Cluster')) {
    <div class="blurred-overlay">
      <div class="blurred-content">
        <div class="blurred-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
            <path d="M12 6v6l4 2" />
            <path d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
          </svg>
        </div>
        @if(userData.role_id == constant.RoleId.masterAgency && userAgencyType == 'SAAS'){
        <p class="blurred-message">
          Select “Master Agency” in Change All Customer 3pl Setup to add or manage your mapped 3PL.
        </p>
        }
        @if(userData.role_id == constant.RoleId.masterAgency && userAgencyType == 'Customer'){
        <p class="blurred-message">
          Select “Customer Master in Change All Customer 3pl Setup to add or manage your mapped 3PL.
        </p>
        }
        @if(userData.role_id == constant.RoleId.agency && userAgencyType == 'SAAS'){
        <p class="blurred-message">
          Select “Agency” in Change All Customer 3pl Setup to add or manage your mapped 3PL.
        </p>
        }
        @if(userData.role_id == constant.RoleId.agency && userAgencyType == 'Customer'){
        <p class="blurred-message">
          Select “Customer Group” in Change All Customer 3pl Setup to add or manage your mapped 3PL.
        </p>
        }
        @if(userData.role_id == constant.RoleId.vendor){
        <p class="blurred-message">
          Select “Own” in Change All Customer 3pl Setup to add or manage your mapped 3PL.
        </p>
        }
      </div>
    </div>
    }
  </div>

  <div class="card-footer action-buttons-container justify-content-end mt-3">
    <button type="button" class="btn ad-btn-small active" (click)="deliveryPartnerAdd()"
      [disabled]="dp_setup !== 'Own'">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" stroke="currentColor" stroke-width="1.5">
          <path
            d="M2.364 12.958c-.38-2.637-.57-3.956-.029-5.083s1.691-1.813 3.992-3.183l1.385-.825C9.8 2.622 10.846 2 12 2s2.199.622 4.288 1.867l1.385.825c2.3 1.37 3.451 2.056 3.992 3.183s.35 2.446-.03 5.083l-.278 1.937c-.487 3.388-.731 5.081-1.906 6.093S16.553 22 13.106 22h-2.212c-3.447 0-5.17 0-6.345-1.012s-1.419-2.705-1.906-6.093z" />
          <path stroke-linecap="round" d="M15 13h-3m0 0H9m3 0v-3m0 3v3" />
        </g>
      </svg>
      <span>Add</span>
    </button>
    @if (UserDeliveryPartnerMap.length) {
    <button type="button" class="btn ad-btn-small active" (click)="updateData()" [disabled]="dp_setup !== 'Own'">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none">
          <g clip-path="url(#solarSmartphoneUpdateOutline0)">
            <path fill="currentColor" fill-rule="evenodd"
              d="M2.035 3.25c.33-2.221 2.1-4 4.346-4C7.726-.75 8.914-.1 9.71.892a.75.75 0 1 1-1.17.938C7.998 1.154 7.224.75 6.38.75c-1.326 0-2.52 1.03-2.826 2.506a.75.75 0 0 1 .459 1.25l-.73.8a.75.75 0 0 1-1.108 0l-.73-.8a.75.75 0 0 1 .59-1.255M12.25 2a.75.75 0 0 1 .752-.748c1.547.004 2.8.03 3.807.2c1.028.175 1.872.512 2.55 1.19c.748.749 1.08 1.698 1.238 2.87c.153 1.14.153 2.595.153 4.433v4.112c0 1.838 0 3.294-.153 4.433c-.158 1.172-.49 2.121-1.238 2.87c-.749.748-1.698 1.08-2.87 1.238c-1.14.153-2.595.153-4.433.153h-.112c-1.838 0-3.294 0-4.433-.153c-1.172-.158-2.121-.49-2.87-1.238c-.748-.749-1.08-1.698-1.238-2.87c-.153-1.14-.153-2.595-.153-4.433v-3.055a.75.75 0 0 1 1.5 0V14c0 1.907.002 3.262.14 4.29c.135 1.005.389 1.585.812 2.008s1.003.677 2.009.812c1.028.138 2.382.14 4.289.14s3.262-.002 4.29-.14c1.005-.135 1.585-.389 2.008-.812s.677-1.003.812-2.009c.138-1.027.14-2.382.14-4.289v-4c0-1.907-.002-3.261-.14-4.29c-.135-1.005-.389-1.585-.812-2.008c-.385-.385-.898-.629-1.74-.772c-.864-.146-1.993-.174-3.56-.18A.75.75 0 0 1 12.25 2m-1.98.451a.75.75 0 0 1 .554.244l.73.8a.75.75 0 0 1-.59 1.255c-.328 2.221-2.098 4-4.344 4c-1.25 0-2.368-.562-3.158-1.44a.75.75 0 1 1 1.115-1.004c.534.594 1.258.944 2.043.944c1.326 0 2.52-1.03 2.826-2.506a.75.75 0 0 1-.459-1.25l.73-.8a.75.75 0 0 1 .554-.244M8.25 19a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75"
              clip-rule="evenodd" />
          </g>
          <defs>
            <clipPath id="solarSmartphoneUpdateOutline0">
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </g>
      </svg>
      <span>Update</span>
    </button>
    }
  </div>
  }
  @if (!deliveryPartnerShow) {
  <form [formGroup]="dpFormGroup" (ngSubmit)="addDeliveryPartner()" class="ad-flex-parent">
    <div class="ad-delivery-partner-container">
      <div class="ad-delivery-partner-container-inner">
        <div class="row mb-3">
          <div class="col-md-6 col-sm-12">
            <div class="ad-form-group mb-0">
              <label class="ad-control-label">Delivery partner</label>
              <ng-select class="ad-select" bindLabel="full_name" bindValue="user_id" placeholder="Select"
                (change)="thirdPartyname($event)" formControlName="delivery_partner_user_id" [searchable]="true"
                [items]="deliveryPartnerList">
              </ng-select>
              @if (dpFormGroup.get('delivery_partner_user_id')?.invalid && submitted) {
              <p class="mb-0 ad-errors">Please choose delivery partner</p>
              }
            </div>
          </div>
          @if(dp_push_mechanisum != 'Parallel'){
          <div class="col-md-6 col-sm-12">
            <div class="ad-form-group mb-0">
              <label class="ad-control-label">Order waiting time(mins)</label>
              <input class="ad-form-control" id="order-time" type="number" placeholder="Enter order time"
                formControlName="waiting_time_in_min" appOnlyNumber>
              @if (dpFormGroup.get('waiting_time_in_min')?.errors?.['required'] && submitted) {
              <p class="mb-0 ad-errors">Order waiting time is required</p>
              }
              @if(dpFormGroup.get('waiting_time_in_min')?.errors?.['negativeValue']) {
              <p class="mb-0 ad-errors">Order waiting time cannot be negative</p>
              }
              @if(dpFormGroup.get('waiting_time_in_min')?.errors?.['outOfRange']) {
              <p class="mb-0 ad-errors">Order waiting time must be between 1 - 60 minutes</p>
              }
              @if(dpFormGroup.get('waiting_time_in_min')?.errors?.['invalidNumber']) {
              <p class="mb-0 ad-errors">Please enter a valid number</p>
              }
            </div>
          </div>
          }
        </div>
      </div>
    </div>

    <div class="card-footer action-buttons-container justify-content-end mt-3">
      <button type="button" class="btn ad-btn-small active" (click)="backBtn()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="m4 12l6-6m-6 6l6 6m-6-6h10.5m5.5 0h-2.5" />
        </svg>
        <span>Back</span>
      </button>
      <button type="submit" class="btn ad-btn-small active">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M7.558 3.75H7.25a3.5 3.5 0 0 0-3.5 3.5v9.827a3.173 3.173 0 0 0 3.173 3.173v0m.635-16.5v2.442a2 2 0 0 0 2 2h2.346a2 2 0 0 0 2-2V3.75m-6.346 0h6.346m0 0h.026a3 3 0 0 1 2.122.879l3.173 3.173a3.5 3.5 0 0 1 1.025 2.475v6.8a3.173 3.173 0 0 1-3.173 3.173v0m-10.154 0V15a3 3 0 0 1 3-3h4.154a3 3 0 0 1 3 3v5.25m-10.154 0h10.154" />
        </svg>
        <span>Save</span>
      </button>
    </div>
  </form>
  }
</div>